export default function PrivacyPolicy({ t, lang }) {
    return (
        <div className="container my-5" style={{ maxWidth: "1000px" }}>

            <section className="mb-5 text-start">
                <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>
                Politique de confidentialité
                </h5>
                <p className="text-muted">
                La présente politique de confidentialité a pour objectif d’informer les utilisateurs
                du site sur la manière dont leurs données personnelles sont collectées et traitées,
                conformément au Règlement Général sur la Protection des Données (RGPD).
                </p>
            </section>

            <section className="mb-5 text-start">
                <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>
                Responsable du traitement
                </h5>
                <p className="text-muted">
                Le responsable du traitement des données est :<br />
                HUGUET Julie<br />
                Email : contact@juliehuguet.com
                </p>
            </section>

            <section className="mb-5 text-start">
                <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>
                Données collectées
                </h5>
                <p className="text-muted">
                Les données susceptibles d’être collectées via le formulaire de contact sont :
                <br /><br />
                – Nom<br />
                – Adresse e-mail<br />
                – Contenu du message
                <br /><br />
                Aucune donnée sensible n’est collectée.
                </p>
            </section>

            <section className="mb-5 text-start">
                <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>
                Finalité du traitement
                </h5>
                <p className="text-muted">
                Les données sont collectées uniquement dans le but de répondre aux demandes
                envoyées via le formulaire de contact.
                Elles ne sont ni vendues, ni cédées, ni utilisées à des fins commerciales.
                </p>
            </section>

            <section className="mb-5 text-start">
                <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>
                Durée de conservation
                </h5>
                <p className="text-muted">
                Les données sont conservées uniquement le temps nécessaire au traitement
                de la demande, puis supprimées.
                </p>
            </section>

            <section className="mb-5 text-start">
                <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>
                Contenus intégrés depuis YouTube
                </h5>
                <p className="text-muted">
                Le site intègre des vidéos hébergées sur la plateforme YouTube.
                Lors de la consultation de ces vidéos, des données peuvent être collectées
                par YouTube (Google Ireland Limited), notamment via des cookies.
                <br /><br />
                Ces traitements sont réalisés sous la responsabilité de YouTube,
                conformément à leur propre politique de confidentialité :
                https://policies.google.com/privacy
                <br /><br />
                Des données peuvent être transférées hors de l’Union Européenne
                dans le cadre de ces services tiers.
                </p>
            </section>

            <section className="mb-5 text-start">
                <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>
                Droits des utilisateurs
                </h5>
                <p className="text-muted">
                Conformément au RGPD, vous disposez des droits suivants :
                <br /><br />
                – Droit d’accès<br />
                – Droit de rectification<br />
                – Droit à l’effacement<br />
                – Droit à la limitation du traitement
                <br /><br />
                Vous pouvez exercer ces droits en envoyant un email à :
                contact@juliehuguet.com
                </p>
            </section>

            </div>
        
    )
}